
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.69 5.435a1.152 1.152 0 110-2.304 1.152 1.152 0 010 2.304z","fill":"#585858"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.94.016h.062l4.61.33a2.227 2.227 0 012.02 2.018l.337 4.606a1.45 1.45 0 01-.4 1.152L9.088 14.6A1.43 1.43 0 018.065 15a2.144 2.144 0 01-1.536-.668L1.635 9.45c-.76-.63-.88-1.75-.269-2.526L7.888.4A1.452 1.452 0 018.91 0l.03.016zM8.91 1.25a.23.23 0 00-.138 0L2.28 7.738a.767.767 0 00.276.768l4.909 4.905a.938.938 0 00.622.3h.13l6.469-6.518a.237.237 0 000-.169l-.338-4.606a.975.975 0 00-.8-.821l-4.608-.33-.031-.016z","fill":"#585858"}})])
          )
        }
      }
    